import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogSize } from '@wcg/frontend-framework';

@Component({
  selector: 'prompt-check-dialog',
  templateUrl: './prompt-check-dialog.component.html',
  styleUrls: ['./prompt-check-dialog.component.css'],
  standalone: false,
})
export class PromptCheckDialogComponent {
  private readonly _dialogRef = inject(
    MatDialogRef<PromptCheckDialogComponent>,
  );
  public data = inject(MAT_DIALOG_DATA);

  size = DialogSize.SMALL;

  delete() {
    this._dialogRef.close(true);
  }

  cancel() {
    this._dialogRef.close();
  }
}
